/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const tileTokens = {
  BackgroundColorBaseDefault: '#ffffff',
  BackgroundColorAccent1Default: '#fbf8f7',
  BackgroundColorAccent2Default: '#e1ddf2',
  BackgroundColorAccent3Default: '#eaf0f8',
  BackgroundColorAccent4Default: '#f4f4f4',
  BorderColorBaseDefault: '#dedfdf',
  BorderStyleBaseDefault: 'solid',
  BorderWidthBaseDefault: '1px',
  BorderRadiusBaseDefault: '0px',
  SpacingBaseDefault: '20px',
} as const;
